import { ref } from 'vue'
import getSensorData from '../../../../composables/getSensorData'

const processBandData = () => {
  const bandData = ref([])
  const shouldRenderBandCharts = ref(false)

  const { fetchTimeData, fetchDataForChart } = getSensorData()

  const renderBandCharts = async (sessionId, userDevices) => {
    let temp1Promise
    let temp2Promise
    let temp3Promise
    let temp4Promise
    let hum1Promise
    let hum2Promise
    let hum3Promise
    let hum4Promise

    const timeData = await fetchTimeData(sessionId)

    temp1Promise = fetchDataForChart(sessionId, 'Temperature0', userDevices, timeData)
    temp2Promise = fetchDataForChart(sessionId, 'Temperature1', userDevices, timeData)
    temp3Promise = fetchDataForChart(sessionId, 'Temperature2', userDevices, timeData)
    temp4Promise = fetchDataForChart(sessionId, 'Temperature3', userDevices, timeData)

    hum1Promise = fetchDataForChart(sessionId, 'Humidity0', userDevices, timeData)
    hum2Promise = fetchDataForChart(sessionId, 'Humidity1', userDevices, timeData)
    hum3Promise = fetchDataForChart(sessionId, 'Humidity2', userDevices, timeData)
    hum4Promise = fetchDataForChart(sessionId, 'Humidity3', userDevices, timeData)

    Promise.all([
      temp1Promise,
      temp2Promise,
      temp3Promise,
      temp4Promise,
      hum1Promise,
      hum2Promise,
      hum3Promise,
      hum4Promise
    ]).then((res) => {
      let groupData = []
      bandData.value = [
        { id: 'band-temp-1', title: 'Temperature 1', data: res[0] },
        { id: 'band-temp-2', title: 'Temperature 2', data: res[1] },
        { id: 'band-temp-3', title: 'Temperature 3', data: res[2] },
        { id: 'band-temp-4', title: 'Temperature 4', data: res[3] },
        { id: 'band-hum-1', title: 'Humidity 1', data: res[4] },
        { id: 'band-hum-2', title: 'Humidity 2', data: res[5] },
        { id: 'band-hum-3', title: 'Humidity 3', data: res[6] },
        { id: 'band-hum-4', title: 'Humidity 4', data: res[7] }
      ]
      bandData.value.forEach((data) => {
        groupData.push({
          name: data.title,
          data: data.data[0].data
        })
      })
      const side = res[0][0].name
      bandData.value.push({ id: `band-${side}-group`, title: `${side} Group`, data: groupData })
      if (res[0].length > 1) {
        groupData = []
        bandData.value = bandData.value.filter((data) => data.data)
        bandData.value.forEach((data) => {
          groupData.push({
            name: data.title,
            data: data.data[1].data
          })
        })
        const side = res[0][1].name
        bandData.value.push({ id: `band-${side}-group`, title: `${side} Group`, data: groupData })
      }
      shouldRenderBandCharts.value = true
    })
  }

  return {
    bandData,
    shouldRenderBandCharts,
    renderBandCharts
  }
}
export default processBandData
